<template>
  <div class="jobs-mailing-container">
    <pc-nav-bar/>
    <div class="mailing-content">
      <div class="mailing-tabs">
        <div class="tab-item color_9c cursor_p" :class="{'tab-active': tab === '1'}" @click="changeTab('1')">已投职位</div>
        <div class="tab-item color_9c cursor_p" :class="{'tab-active': tab === '2'}" @click="changeTab('2')">收藏职位</div>
        <div class="tab-item color_9c cursor_p" :class="{'tab-active': tab === '3'}" @click="changeTab('3')">关注公司</div>
      </div>
      <div class="mailing-data-content">
        <div class="list-container">
          <skeleton v-if="pageLoadingShow"></skeleton>
          <!-- 已投递职位 -->
          <template v-else-if="tab === '1'">
            <template v-for="(item, index) in applicationList">
              <item-list :key="index" :data="item"/>
            </template>
             <template>
              <no-choose :text="text='暂无投递'" v-show='applicationList.length == 0'/>
            </template>
            <pagination :current-page="applicationPage" :page-size="10" :total="applicationTotal"
                        @current-change="changeCurrentPage"></pagination>
          </template>
          <!-- 已收藏职位 -->
          <template v-else-if="tab === '2'">
            <template v-for="(item, index) in favoriteList" v-show="favoriteList" >
              <item-list :key="index" :data="item"/>
            </template>
            <template>
              <no-choose :text="text='暂无收藏'" v-show='favoriteList.length == 0'/>
            </template>
            <pagination :current-page="favoritePage" :page-size="10" :total="favoriteTotal"
                        @current-change="changeCurrentPage"></pagination>
          </template>
          <!-- 已关注公司 -->
          <template v-else-if="tab === '3'">
            <template v-if="followList && followList.length" >
              <comp-company-card v-for="(item, index) in followList" :key="index" :data="item" />
            </template>
            <template v-else>
              <no-choose :text="text='暂无关注'"/>
            </template>
            <pagination :current-page="followPage" :page-size="10" :total="followTotal"
                        @current-change="changeCurrentPage"></pagination>
          </template>
        </div>
        <div class="jobs-data-container">
          <wx-qr-code></wx-qr-code>
        </div>
      </div>
    </div>
    <pc-footer/>
  </div>
</template>

<script>
	import pcNavBar from '../../components/base/navbar'
	import pcFooter from '../../components/base/pcFooter'
	import skeleton from '../../components/base/skeleton'
	import wxQrCode from '../../components/wxQrcode'
	import pagination from '../components/page'
  import itemList from './components/itemList'
  import noChoose from './components/no_choose'
  import CompCompanyCard from './components/followCompanyCard.vue'

	import api from '../../api'

	export default {
		name: 'mailing',
		data () {
			return {
				tab: 1,
				pageLoadingShow: true,
				applicationPage: 1,
				applicationList: [],
				applicationTotal: -1,
				favoritePage: 1,
				favoriteList: [],
        favoriteTotal: -1,
        followPage: 1,
        followList: [],
        followTotal: -1
			}
		},
		mounted () {
			this.initListData()
		},
		computed: {},
		watch: {},
		components: {
			pcNavBar,
			pcFooter,
			wxQrCode,
			skeleton,
			pagination,
      itemList,
      noChoose,
      CompCompanyCard
    },
		methods: {
			// 切换tab
			changeTab (value) {
				this.tab = value
			},
			// 初始化数据
			async initListData () {
				let { tab } = this.$route.query
				this.tab = tab || '1'
				this.getApplicationList()
        await this.getFollowList()
				await this.getFavoriteList()
				this.pageLoadingShow = false
			},
			// 切换当前页码
			changeCurrentPage (page) {
				if (this.tab === '1') {
					this.applicationPage = page
					this.getApplicationList()
				} else if (this.tab === '2') {
					this.favoritePage = page
          this.getFavoriteList()
				}  else if (this.tab === '3') {
					this.followPage = page
          this.getFollowList()
				}
			},
      // 获取关注公司列表
      async getFollowList () {
        try {
          let params = {
            page: this.followPage,
            page_size: 10
          }
          let res = await api.jobs.getFollowCompanyList(params)
          if (res.code === 1000) {
            this.followList = res.data.company_list || []
            this.followTotal = res.data.total_count
          }
        } catch (error) {
          console.log(error)
        }
      },
			// 获取已投职位数据
			async getApplicationList () {
				let res = await api.jobs.getApplicationList({
					page: this.applicationPage,
					page_size: 10
        })
				if (res.code === 1000) {
					this.applicationList = res.data.application_jobs
					this.applicationTotal = res.data.application_job_count
				}
			},
			// 获取收藏职位列表数据
			async getFavoriteList () {
				let res = await api.jobs.getFavoriteList({
					page: this.favoritePage,
					page_size: 10
        })
				if (res.code === 1000) {
					this.favoriteList = res.data.favorite_jobs
					this.favoriteTotal = res.data.favorite_job_count
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '../../assets/css/public';
  .jobs-mailing-container {
    background-color: #F5F5F7;
    padding-top: 55px;
    .mailing-content {
      width: 1196px;
      padding-top: 16px;
      margin: 0 auto;
      .mailing-tabs {
        display: flex;
        align-items: center;
        width: 100%;
        height: 52px;
        padding-left: 32px;
        background-color: #FFffff;
        margin-bottom: 16px;
        box-sizing: border-box;
        .tab-item {
          margin-right: 64px;
        }
        .tab-active {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #404040;
          margin-bottom: -17px;
          &:after {
            content: '';
            width: 32px;
            height: 2px;
            background-color: #404040;
            margin-top: 15px;
          }
        }
      }
      .mailing-data-content {
        display: flex;
        width: 100%;
        .list-container {
          flex: 1;
          margin-right: 16px;
          .jobs-item-list-main {
            margin-bottom: 16px;
          }
          .new-pager-main {
            padding-bottom: 20px;
          }
        }
        .jobs-data-container {
          width: 300px;
        }
      }
    }
  }
</style>
